import { defineAsyncComponent } from 'vue'
import { registerComponent } from '../../lego-land/components/registries/componentRegistry'

/**
 * Registers common's smart (data-coupled) components into lego-land's
 * config-driven component registry at boot. lego-land keeps the purely
 * presentational components; anything that fetches, navigates, or renders
 * other common components (ads, search, weather) lives here in common and
 * is contributed to the registry at runtime, the same pattern as
 * registerTemplate.
 *
 * This plugin lives in common, so it boots on every tenant, while only the
 * portal layout ever resolves these names. Static imports would pull the ad
 * stack, the searchbox and its typeahead composable into every brand's
 * bundle for nothing, so each one is loaded on first render instead. The
 * registry only stores the definition, and the layout renders it through
 * `<component :is>`, so an async definition behaves the same.
 */
export default defineNuxtPlugin(() => {
  registerComponent(
    'AdSlot',
    defineAsyncComponent(() => import('../components/AdSlot/AdSlot.vue'))
  )
  registerComponent(
    'PortalFeedAd',
    defineAsyncComponent(
      () => import('../components/PortalFeedAd/PortalFeedAd.vue')
    )
  )
  registerComponent(
    'PortalFooter',
    defineAsyncComponent(
      () => import('../components/PortalFooter/PortalFooter.vue')
    )
  )
  registerComponent(
    'PortalGamesList',
    defineAsyncComponent(
      () => import('../components/PortalGamesList/PortalGamesList.vue')
    )
  )
  registerComponent(
    'SiteHeader',
    defineAsyncComponent(
      () => import('../components/SiteHeader/SiteHeader.vue')
    )
  )
})
